import { render, staticRenderFns } from "./sort-order.vue?vue&type=template&id=c2e90caa&"
import script from "./sort-order.vue?vue&type=script&lang=ts&"
export * from "./sort-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports